export const isTooltipHoverable = (showHoverTooltip?: boolean) => {
    // Used to set the `open` prop of <Tooltip /> passed into the `open` prop of <TippyTooltip />
    // <TippyTooltip /> is from react-tippy (https://github.com/tvkhoa/react-tippy)
    // Setting the `open` prop as `undefined` leaves interactions (e.g., hover) and the component logic to determine the open or closed status of the tooltip
    // The values `false` or `true` force the tooltip to be closed or open respectively
    return showHoverTooltip ? undefined : false;
};
